import * as React from 'react';
import { useEffect, useRef, useState } from 'react';

import MiniProfile from 'bundles/classmates/components/MiniProfile';

type MiniProfileRendererProps = {
  courseRole?: string;
  externalId: string;
  showMini: boolean;
  source: string;
  toolTipId?: string;
  fullName: string;
  profileImageUrl?: string;
};

const MiniProfileRenderer = ({
  courseRole,
  externalId,
  showMini,
  source,
  toolTipId,
  fullName,
  profileImageUrl,
}: MiniProfileRendererProps) => {
  const profileEl = useRef<HTMLElement>(null);
  const MAX_HEIGHT = 200;

  const MIN_HOVER_TIME = 500;

  const [orientation, setOrientation] = useState<'South' | 'North'>('South');
  const [showMiniInternal, setShowMiniInternal] = useState(false);

  useEffect(() => {
    if (profileEl?.current?.getBoundingClientRect) {
      const hasEnoughRoom = profileEl.current.getBoundingClientRect().top + MAX_HEIGHT < window.innerHeight;
      setOrientation(hasEnoughRoom ? 'South' : 'North');
    }
  }, [profileEl]);

  useEffect(() => {
    let timer = -1;
    if (!showMini) {
      setShowMiniInternal(false);
      clearTimeout(timer);
    } else {
      timer = window.setTimeout(() => {
        setShowMiniInternal(true);
      }, MIN_HOVER_TIME);
    }
    return () => clearTimeout(timer);
  }, [showMini]);

  return showMiniInternal ? (
    <MiniProfile
      ref={profileEl}
      externalId={externalId}
      courseRole={courseRole}
      orientationClass={source + orientation}
      toolTipId={toolTipId}
      fullName={fullName}
      profileImageUrl={profileImageUrl}
    />
  ) : null;
};

export default MiniProfileRenderer;
